<template>
  <div>
    <h2>{{ $t('runnerOut.selectRunner') }}</h2>
    <p>{{ $t('runnerOut.whoIsOut') }}</p>
    <div
        class="radio-group"
    >
      <template

          v-for="runner in runners"
          :key="runner.id">

        <input
            class="form-check-input"
            type="radio"
            :id="'radioPlayer' + runner.id"
            :value="runner"
            v-model="selectedPlayer"
            name="playerOptions"
        />
        <label
            class="form-check-label"
            :for="'radioPlayer' + runner.id"
        >
          {{ player(runner.id).number }} ({{ player(runner.id).gender }}) on Base {{ runner.curPos }}
        </label>
      </template>
    </div>
    <div class="mt-3 d-flex gap-3">
      <button @click="confirmSelection" class="btn btn-bb5-yellow w-100 m-0 p-2 my-2">{{ $t('confirm') }}</button>
    </div>
  </div>
</template>

<script>
import core from "@/mixins/Core";

export default {
  name: "RunnerOut",
  props: {
    runners: Array,
  },
  data() {
    return {
      selectedPlayer: null, // To track the selected player
      strickMode: true
    };
  },
  mixins: [core],
  methods: {
    confirmSelection() {
      if (this.selectedPlayer) {
        this.$emit('runnerout', this.selectedPlayer.id, );
      } else {
        alert(this.$t('runnerOut.alert')
        );
      }
    },
    player(id) {
      return this.getTeamPlayerById(id)
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.radio-group {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
  width: 100%
}

.radio-group label {
  display: inline-block;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  border: 1px solid #000;
  border-radius: 8px;
  background-color: #fff;
  color: #000;
  position: relative;
  transition: all 0.3s ease;
  text-align: center;
  user-select: none;
}

.radio-group input[type="radio"] {
  display: none;
}

.radio-group label::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) scale(0);
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  transition: transform 0.2s ease;
}

.radio-group input[type="radio"]:checked + label {
  background-color: var(--bb5-yellow);
  color: #000;
  border-color: var(--bb5-yellow);
}

.radio-group input[type="radio"]:checked + label::after {
  transform: translateY(-50%) scale(1);
}

.radio-group label:hover {
  background-color: #ddd;
  border-color: #aaa;
}
</style>
